export default __webpack_public_path__ + "static/media/event_plateform.2787c89f.png";